export default __webpack_public_path__ + "static/media/olacacheada.55c04b1f.jpg";